// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__23Q1d","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3PI9s"};